<div class="chat-wrapper" >
    <!-- Left side Chat Panel -->
    <div class="sidebar">
      <div class="sidebar-header">
        <h3 class="lsc">List Of Connections ({{totalUser}}) </h3>
        <!-- <button class="add-btn">+ Add New</button> -->
      </div>


      <!-- Category sections-->
      <div class="tabs">
        <button *ngFor="let card of documentCategories" class="tab" [ngClass]="{ active: card.isActive }"
          (click)="onCategoryClick(card)">
          {{ card.title }}
        </button>
      </div>
  
      <input type="text" class="search-bar" placeholder="Search for People" [(ngModel)]="searchText"/>

      <div *ngIf="selectedCategoryTitle === 'Health' && showNoHealthConnectionsMsg" class="no-connection-msg">
        No connections in Health Category!
      </div>

      <div *ngIf="!showNoHealthConnectionsMsg">
      <div class="contact-list" *ngFor="let rel of filteredUsers">

      <!-- contact rel lists -->
        <!-- consumer-->
        <div class="contact" *ngIf="rel['isaccepted'] && rel['biztype'] === 'consumer'" [class.active]="selectedContact === rel" (click)="onSelectContact(rel)">
          <div class="avatar">
            <img *ngIf="rel.profile_url" [src]="rel.profile_url" alt="User" />
            <div *ngIf="!rel.profile_url" class="avatar-text">
              {{ rel.business_name.charAt(0) }}
            </div>
          </div>
        
          <div class="contact-info">
            <p class="name">{{ rel.business_name }}</p>
            <!-- <p class="msg-preview">Yeah Sure. I'll check and let you k...</p> -->
          </div>
          <!-- <span class="time">04:07 PM</span> -->
        </div>
        <!-- consumer-->

        <!-- health. legal & finance -->
        <ng-container *ngIf="rel['isaccepted'] && rel['biztype'] !== 'consumer'">
          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" class="firm-panel"
            [expanded]="action == rel['id']">
        
            <mat-expansion-panel-header (click)="loadFirmUsers(panelOpenState, rel); onSelectFirm(rel['id']); onPanelOpened(rel['id'])" 
            [ngClass]="{'actived': selectedFirmId === rel['id'] && !selectedUserId,
                'active-with-user': selectedFirmId === rel['id'] && selectedUserId}" class="matHead">
              <div class="chat-card">
              <div class="avatar">
                <img *ngIf="rel.profile_url" [src]="rel.profile_url" alt="User" />
                <div *ngIf="!rel.profile_url" class="avatar-text">
                  {{ rel.business_name.charAt(0) }}
                </div>
              </div>
        
                <div class="chat-info">
                  <div class="user-name">{{ rel.business_name }}</div>
                  <div class="msg-preview">Tap to view members</div>
                </div>
                <!-- <mat-icon class="expand-icon">expand_more</mat-icon> -->
              </div>
            </mat-expansion-panel-header>
        
            <!-- Firm Users Name -->
            <!-- <div class="chat-card sub-user-card" (click)="chatUsers(selectedFirmJid, selectedFirm, true, '', 'Admin', '')">
              <i class="fa fa-user-circle fa-lg avatar-icon"></i>
              <div class="chat-info">
                <div class="user-name">{{ selectedFirm }}</div>
                <div class="msg-preview">Firm Admin</div>
              </div>
            </div> -->
        
            <!-- Firm Members Name -->
            <!-- <div *ngFor="let user of firmUsersList" class="chat-card sub-user-card"
              [class.active]="selectedContact === user" (click)="onSelectContacts(user)"> -->
              <div *ngFor="let user of firmUsersList" class="chat-card sub-user-card"
                [class.active]="selectedUserId === user && selectedFirmId === rel['id']" 
                (click)="onSelectContactId(user, rel['id'])">

              <div class="avatar">
                <img *ngIf="rel.profile_url" [src]="rel.profile_url" alt="User" />
                <div *ngIf="!rel.profile_url" class="avatar-text">
                  {{ rel.business_name.charAt(0) }}
                </div>
              </div>
              <div class="chat-info">
                <div class="user-name">{{ user['name'] }}</div>
                <!-- <div class="msg-preview">Firm Member</div> -->
              </div>
            </div>
        
          </mat-expansion-panel>
        </ng-container>
        <!-- health. legal & finance -->
      <!-- contact rel lists -->


        <!-- <div class="contact active">
          <img src="https://i.pravatar.cc/40?img=3" alt="User" />
          <div class="contact-info">
            <p class="name">Thomas Kelvin</p>
            <p class="msg-preview">Yeah Sure. I'll check and let you k...</p>
          </div>
          <span class="time">04:07 PM</span>
        </div>
  
        <div class="contact typing">
          <img src="https://i.pravatar.cc/40?img=4" alt="User" />
          <div class="contact-info">
            <p class="name">Maddy Kennedy</p>
            <p class="typing-status">Maddy is typing...</p>
          </div>
          <span class="dot online"></span>
        </div>
  
        <div class="contact unread">
          <img src="https://i.pravatar.cc/40?img=5" alt="User" />
          <div class="contact-info">
            <p class="name">Robert Foxer</p>
            <p class="msg-preview">I'll check with them once.</p>
          </div>
          <span class="badge">100</span>
        </div> -->
  
      </div>
      </div>
    </div>
    <!-- Left side Chat Panel -->
  
    <!-- Right side Chat Panel -->
    <div class="chat-panel" *ngIf="selectedContact">
      <div class="chat-header" >
        <div class="user">
          <img 
            *ngIf="selectedContact.profile_url" 
            [src]="selectedContact.profile_url" 
            alt="User"
          />
          <div *ngIf="!selectedContact.profile_url" class="avatar-text">
            {{ selectedContact.business_name?.charAt(0) || selectedContact.name?.charAt(0) || '?' }}
          </div>

          <div class="userstatus">
            <h4 class="username">{{ selectedContact.business_name || selectedContact.name}}</h4>
            <!-- <span class="status">Offline</span> Replace with dynamic status if needed -->
          </div>
        </div>
        <div class="icons">
          <i class="fas fa-video"  (click)="StartVideo()"></i>
          <!-- <i class="fas fa-search"></i> -->
           <!-- <input type="text" id="space" class="form-control textbox space" 
           (input)="restricttextSpace($event)" placeholder="Search" autocomplete="off" 
           [(ngModel)]="clientSearch"> -->

          <div class="search-container">
            <mat-form-field appearance="outline">
              <mat-label>Search</mat-label>
              <input matInput type="search" (input)="restricttextSpace($event)" autocomplete="off" [(ngModel)]="clientSearch" />
              <button matSuffix mat-icon-button aria-label="Search">
                <mat-icon>search</mat-icon>
              </button>
            </mat-form-field>
          </div>

        </div>
      </div>
  
      <div class="chat-body">
        <!-- <div class="search-section">
          <div class="search-container">
            <input type="text" (input)="restricttextSpace($event)" class="search-text" placeholder="Search" autocomplete="off"
              [(ngModel)]="clientSearch" />
            <i class="material-icons search-icon">search</i>
          </div>
        </div> -->

      <div *ngFor="let msg of messages | filter:clientSearch"
          [ngClass]="{'message-container': true, 'right2': msg.action === 'SENT', 'left2': msg.action !== 'SENT'}">
        
        <div class="message2">
          <p [innerHTML]="msg.text "></p>
        </div>
        
        <span class="time2">{{ msg.timestamp }}</span>
      </div>
    </div>

      <div class="chat-input">
        <!-- <input type="text" id='messege_input' #messageinput [(ngModel)]="messegeInput" placeholder="Type a message..." /> -->         
        <!-- <input type="text" #messege_input placeholder="Type a message..." (keydown)="onKeyDown($event)" [(ngModel)]="messegeInput" required=""/> -->
          <textarea class="form-control textbox chatinput" id="title" name="caseno" #messege_input (keydown)="onKeyDown($event)"
            [(ngModel)]="messegeInput" required="" placeholder="Type your message...">
          </textarea>

        <button>
          <!-- <i class="fas fa-paper-plane" (click)="sendMessage(messageinput.value)"></i> -->
              <i id="btn_send" class="fa fa-paper-plane" [ngClass]="{'disabled':  messegeInput.length==0 || isMessageEmpty()}"
               (click)="sendMessage(messege_input.value)" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <!-- if no contact in selected state -->
    <div class="chat-panel" *ngIf="connectionUser && connectionUser.length > 0 && !selectedContact">
      <div class="empty-state2">
        <img src="assets/images/nomessage.svg" alt="No messages" class="empty-image" />
        <h3>Start a Conversation</h3>
        <p style="margin-top: 2px;">By Selecting a Contact or Connection</p>
      </div>
      <div class="encryption-info">
        <mat-icon>lock</mat-icon>
        <span>Your personal messages are end-to-end encrypted</span>
      </div>
    </div>
    <!-- if no contact in selected state -->
     <div class="chat-panel" *ngIf="connectionUser?.length === 0">
      <div class="empty-state2">
        <img src="assets/images/nomessage.svg" alt="No messages" class="empty-image" />
        <h3>No messages yet ...</h3>
        <p *ngIf="selectedCategoryTitle == 'personal'" style="margin-top: 2px;">Start chatting with your contacts and enhance your communication now.</p>
        <button *ngIf="selectedCategoryTitle == 'personal'" class="start-chat-btn" routerLink="/connections">Start Chat</button>
      </div>
    </div>
    <!-- Right side Chat Panel -->
</div>
  
<!-- CHECK if connectionUser is empty -->
<ng-template #checkConnectionUser>
  <ng-container *ngIf="connectionUser?.length === 0; else noUsersTemplate">
    
    <!-- No relationships available -->
    <div class="empty-state">
      <img src="assets/images/nomessage.svg" alt="No messages" class="empty-image" />
      <h3>No Messages Yet...</h3>
      <!-- <p style="margin-top: 2px;">Start chatting with your contacts and enhance your communication now.</p> -->
      <button *ngIf="selectedCategoryTitle == 'personal'" class="start-chat-btn" routerLink="/connections">Start Chat</button>
    </div>

  </ng-container>
</ng-template>

<!-- No category/contact selected yet -->
<ng-template #noUsersTemplate>
  <div class="empty-state">
    <img src="assets/images/nomessage.svg" alt="No messages" class="empty-image" />
    <h3>Start a Conversation</h3>
    <p style="margin-top: 2px;">By Selecting a Contact or Connection</p>
    <button class="start-chat-btn" routerLink="/connections">Start Chat</button>
  </div>
</ng-template>